/**
 * Rest-timer chime — a soft two-tone bell generated at runtime with the
 * Web Audio API so we don't have to ship an audio asset. Two chimes:
 *   • done()   — plays when the rest timer reaches zero
 *   • preview() — used by the Settings toggle to let users hear the sound
 *
 * Sound design: two overlapping sine waves (E5 + G5) with a short attack
 * and an exponential decay, plus a lowpass filter. Feels like a small
 * temple bell — audible without being startling.
 */
let sharedCtx = null;

function getContext() {
  if (sharedCtx) return sharedCtx;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    sharedCtx = new Ctx();
    return sharedCtx;
  } catch {
    return null;
  }
}

function playChime(volume = 0.4) {
  const ctx = getContext();
  if (!ctx) return;
  if (ctx.state === 'suspended') {
    // Some browsers keep the context suspended until a user gesture. If we
    // can't resume here it just means the user hasn't tapped anything yet
    // — the next tap will unlock it for future plays.
    ctx.resume().catch(() => {});
  }
  const now = ctx.currentTime;
  const filter = ctx.createBiquadFilter();
  filter.type = 'lowpass';
  filter.frequency.setValueAtTime(2400, now);
  filter.connect(ctx.destination);

  const notes = [
    { freq: 659.25, start: 0, dur: 0.9 },    // E5
    { freq: 783.99, start: 0.08, dur: 0.9 }, // G5
  ];
  notes.forEach((n) => {
    const osc = ctx.createOscillator();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(n.freq, now + n.start);
    const gain = ctx.createGain();
    gain.gain.setValueAtTime(0.0001, now + n.start);
    gain.gain.exponentialRampToValueAtTime(volume, now + n.start + 0.03);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + n.start + n.dur);
    osc.connect(gain).connect(filter);
    osc.start(now + n.start);
    osc.stop(now + n.start + n.dur + 0.05);
  });
}

export const restChime = {
  done: () => playChime(0.45),
  preview: () => playChime(0.32),
};
